
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import type { ExtraInfoEntry } from '../ExtraInfo.vue';

@Component
export default class CheckBox extends Vue {
  @Prop({ required: true })
  readonly entry!: ExtraInfoEntry;

  get checked(): boolean {
    return this.entry.checked ?? false;
  }

  set checked(value: boolean) {
    this.$set(this.entry, 'checked', value); //set reactively, works even if property did not exist previously
  }

  get uid(): any {
    return this._uid;
  }
}
